import { call, put, takeLatest } from 'redux-saga/effects';
import { Companies } from 'services/api';
import {
  companiesPublic,
  companiesPublicSuccess,
  companiesPublicFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* getCompaniesPublicSaga(action) {
  try {
    const { data } = yield call(Companies.allPublic, action.payload);
    yield put(companiesPublicSuccess(data));
  } catch (e) {
    yield put(companiesPublicFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(companiesPublic, getCompaniesPublicSaga);
